import React from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SimpleDialog from "components/SimpleDialog/SimpleDialog";
import DocumentThumbnail from "./DocumentThumbnail";
import { getDocumentMeta } from "../../utils";
import s from "../MerchantDocumentUpload.module.scss";

const PreviewDialog = ({
  open,
  previewDocument,
  previewDocuments,
  previewIndex,
  onPrev,
  onNext,
  onClose,
  onJump,
  disablePrev,
  disableNext,
  t,
  localePrefix,
}) => (
  <SimpleDialog
    open={open}
    dialogOncloseFn={onClose} 
    title={previewDocument?.name || t(`${localePrefix}dialog.previewTitle`)}
    maxWidth="sm"
    negativeAction={t(`${localePrefix}dialog.close`)}
    positiveAction={previewDocument?.url ? t(`${localePrefix}dialog.openInNewTab`) : null}
    confirmFn={
      previewDocument?.url
        ? () => window.open(previewDocument.url, "_blank")
        : undefined
    }
    content={
      previewDocument ? (
        <Stack gap={2}>
          <Stack className={s.previewDialogViewport} direction="row" alignItems="center" gap={1}>
            <IconButton
              aria-label="previous document"
              onClick={onPrev}
              disabled={disablePrev}
              size="small"
            >
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>
            <Stack className={s.previewDialogContent}>
              {(() => {
                const { isImage, isPdf, extension } = getDocumentMeta(previewDocument);
                if (isImage) {
                  return (
                    <img
                      src={previewDocument.url}
                      alt={previewDocument.name}
                      className={s.previewDialogImage}
                    />
                  );
                }
                if (isPdf) {
                  return (
                    <iframe
                      src={previewDocument.url}
                      title={previewDocument.name}
                      className={s.previewDialogPdf}
                    />
                  );
                }
                return (
                  <Typography variant="body2">
                    {extension?.toUpperCase() || t(`${localePrefix}.dialog.previewNotSupported`)}
                  </Typography>
                );
              })()}
            </Stack>
            <IconButton
              aria-label="next document"
              onClick={onNext}
              disabled={disableNext}
              size="small"
            >
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
          </Stack>
          {previewDocuments.length > 1 && (
            <Stack direction="row" gap={1} className={s.previewStrip} sx={{ overflowX: "auto", flexWrap: "nowrap" }}>
              {previewDocuments.map((doc, idx) => {
                const isActive = idx === previewIndex;
                return (
                  <Stack
                    key={`${doc.documentId || doc.id || doc.name || "doc"}-${idx}`}
                    className={[
                      s.previewStripItem,
                      isActive ? s.previewStripItemActive : "",
                    ].join(" ")}
                    onClick={() => onJump(idx)}
                  >
                    <DocumentThumbnail document={doc} renderPdfAsObject={true} />
                  </Stack>
                );
              })}
            </Stack>
          )}
        </Stack>
      ) : (
        ""
      )
    }
  />
);

export default PreviewDialog;
